export type UserGender = "MALE" | "FEMALE" | "OTHER" | "";
export type UserStatus = "ACTIVATED" | "DESACTIVATED" | "WAITING" | "DELETED";
export interface User {
  user_id: string;
  user_username: string;
  user_lastname: string;
  user_firstname: string;
  user_email: string;

  user_gender: UserGender;
  uct_consummated_by_user_id: string;
  user_phone_number?: string;

  user_last_connection?: string; //0001-01-01T00:00:00Z
  user_created_at?: string; //0001-01-01T00:00:00Z
  user_updated_at?: string; //0001-01-01T00:00:00Z
}

export type UserExtend = User & UserOrga 
export type UserExtendPatch = UserPatch & UserOrgaPatch

export interface UserRequest {
  user_id: string;
  user_username: string;
  user_lastname: string;
  user_firstname: string;
  user_email: string;
  user_role: UserRole;
  organization_id: string;
  user_gender: UserGender;
  uct_consummated_by_user_id: string;
  user_phone_number?: string;
  user_status: UserStatus;
  user_last_connection?: string; //0001-01-01T00:00:00Z
  user_created_at?: string; //0001-01-01T00:00:00Z
  user_updated_at?: string; //0001-01-01T00:00:00Z
}

export type UserRole = 80000 | 40000 | 20000;

export const userRoles = {
  USER: 20000 as UserRole,
  ADMIN: 40000 as UserRole,
  SUPER_ADMIN: 80000 as UserRole,
};

export const DEFAULT_USER: User = {
  user_id: "",
  user_email: "",
  user_firstname: "",
  user_lastname: "",
  user_gender: "",
  uct_consummated_by_user_id: "",
  user_username: "",
  user_phone_number: "",
};

export type UserPatch = Partial<User>;

export const userGender = {
  MALE: "MALE" as UserGender,
  FEMALE: "FEMALE" as UserGender,
  OTHER: "OTHER" as UserGender,
};

export type CreateNewUserAdminRequest = UserPatch & {
  uct_id: string;
  user_password: string;
};

export const userRolesTraductor = (
  userRole: UserRole | null | undefined
): string => {
  if (userRole === null || userRole === undefined) {
    return "";
  }
  if (userRole === userRoles.ADMIN) {
    return "Administrateur";
  }
  if (userRole === userRoles.SUPER_ADMIN) {
    return "Super Administrateur";
  }

  if (userRole === userRoles.USER) {
    return "Utilisateur";
  }
  return "INCONNU : " + userRole;
};

export const GenreTraductor = (
  genre: UserGender | null | undefined
): string => {
  switch (genre) {
    case "FEMALE":
      return "Femme";
    case "MALE":
      return "Homme";
    case "OTHER":
      return "Autre";
    default:
      return "Inconnu";
  }
};

export const translateUserStatus = (
  status: UserStatus | null | undefined
): string => {
  switch (status) {
    case "ACTIVATED":
      return "Activé";
    case "DESACTIVATED":
      return "Désactivé";
    case "WAITING":
      return "En attente";
    case "DELETED":
      return "Supprimé";
    default:
      return "Inconnu";
  }
};

export interface UserOrga {
  user_orga_id: string;
  user_orga_role: UserRole;
  organization_id: string;
  user_orga_status: UserStatus;
  user_orga_int_id: number;
  user_orga_created_at: string; //0001-01-01T00:00:00Z,
  user_orga_updated_at: string; //0001-01-01T00:00:00Z,
  user_orga_user: string;
  user_orga_client: string;
}

export type UserOrgaPatch = Partial<UserOrga>;

export interface NewChangePasswordRequest {
  rpr_email: string;
}

export type ChangePasswordRequestStatus = "PENDING" | "EXPIRED" | "COMPLETED";

export interface ChangePasswordRequest {
  rpr_id: string,
  rpr_email: string,
  rpr_user: string,
  rpr_created_at: string //2025-05-22T12:36:07.534601Z,
  rpr_updated_at: string //2025-05-22T12:36:07.534601Z,
  rpr_expire_at: string //2025-05-23T14:36:07+02:00,
  rpr_status: ChangePasswordRequestStatus,
  rpr_token: string
}